import { NotificationsStyleModel } from '@/models/header/v2/NotificationsModel'

export function formatNotificationsStyle(data) {
  const h = new NotificationsStyleModel()
  h.fromData(data)

  return h
}
